export const hasPensionsInfoContent = (content) => Boolean(
    content?.profil
    || Array.isArray(content?.aftaler)
    || Array.isArray(content?.udbetalinger)
    || Array.isArray(content?.pensionFlereOplysninger),
);

export const canShowScrapeFileActions = (scrape) => !scrape?.fileId;
